import { faArrowLeft, faArrowRight, faGhost, faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HexColorPicker } from "react-colorful";
import { CanvasDrawer } from "../CanvasDrawer";
import localforage from "localforage";
import { useStickerSectionStore } from "../EditorStore";

export default function BackgroundEditor() {



    const showBackgroundImage = useStickerSectionStore(state => state.showBackgroundImage);
    const setShowBackgroundImage = useStickerSectionStore(state => state.setShowBackgroundImage);

    const backgroundBitmap = useStickerSectionStore(state => state.backgroundBitmap);
    const setBackgroundBitmap = useStickerSectionStore(state => state.setBackgroundBitmap);

    const backgroundColor = useStickerSectionStore(state => state.backgroundColor);
    const setBackgroundColor = useStickerSectionStore(state => state.setBackgroundColor);

    const isPortrait = useStickerSectionStore((state) => state.isPortrait)

    const ghostOpacity = useStickerSectionStore((state) => state.ghostOpacity)
    const setGhostOpacity = useStickerSectionStore((state) => state.setGhostOpacity)



    const uploadBackgroundImage = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.click();

        input.onchange = async () => {
            const file = input.files?.[0];
            if (file) {
                try {
                    const originalBitmap = await createImageBitmap(file);
                    const maxDim = 2048;

                    let bitmap = originalBitmap;
                    let blobToCache: Blob = file;

                    if (originalBitmap.width > maxDim || originalBitmap.height > maxDim) {
                        const width = originalBitmap.width;
                        const height = originalBitmap.height;

                        let newWidth = width;
                        let newHeight = height;

                        if (width > height) {
                            newWidth = maxDim;
                            newHeight = Math.round((height / width) * maxDim);
                        } else {
                            newHeight = maxDim;
                            newWidth = Math.round((width / height) * maxDim);
                        }

                        console.log(`Downsampling background from ${width}x${height} to ${newWidth}x${newHeight}`);

                        const canvas = document.createElement('canvas');
                        canvas.width = newWidth;
                        canvas.height = newHeight;
                        const ctx = canvas.getContext('2d');

                        if (ctx) {
                            ctx.imageSmoothingEnabled = true;
                            ctx.imageSmoothingQuality = 'high';
                            ctx.drawImage(originalBitmap, 0, 0, newWidth, newHeight);

                            blobToCache = await new Promise<Blob>((resolve, reject) => {
                                canvas.toBlob((blob) => {
                                    if (blob) resolve(blob);
                                    else reject(new Error('Failed to create blob'));
                                }, 'image/png');
                            });

                            bitmap = await createImageBitmap(canvas);
                            originalBitmap.close();
                        }
                    }

                    setBackgroundBitmap(bitmap)
                    CanvasDrawer.BackgroundImageBitmap = bitmap

                    const cacheName = "image-cache";
                    const cache = await caches.open(cacheName)

                    const response = new Response(blobToCache, {
                        headers: { "Content-Type": "image/png" },
                    })

                    await cache.put("backgroundImage", response)

                    await localforage.setItem(showBackgroundImageCacheKey, true)
                    setShowBackgroundImage(true)
                    CanvasDrawer.rerenderCanvas()
                } catch (err) {
                    console.error("Failed to load image:", err);
                }
            }
        };
    };

    const showBackgroundImageCacheKey = "showBackgroundImage"

    const changeGhostOpacity = (e: React.ChangeEvent<HTMLInputElement>) => {
        setGhostOpacity(Number(e.target.value))
        if (Number(e.target.value) == 0) {
            alert("For the best-looking result, we recommend leaving ghost visible to fill any blank space.")
        }
    }

    const switchBackgroundMode = async () => {
        const newValue = !showBackgroundImage;
        await localforage.setItem(showBackgroundImageCacheKey, newValue);
        setShowBackgroundImage(newValue);
        CanvasDrawer.rerenderCanvas();
    }

    const changeBackgroundColor = async (color: string) => {
        await localforage.setItem("backgroundColor", color)
        setBackgroundColor(color)

        await localforage.setItem(showBackgroundImageCacheKey, false)
        setShowBackgroundImage(false)
        CanvasDrawer.rerenderCanvas()
    }

    return (
        <div style={{
            position: "fixed",
            top: isPortrait ? "16.5%" : "0",
            left: isPortrait ? "50%" : "6.5vw",
            height: isPortrait ? "17%" : "50vh",
            transform: isPortrait ? "translate(-50%, -50%)" : "",
            zIndex: 9999,
            pointerEvents: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            border: "2px solid white",
            borderRadius: "10px",
            width: isPortrait ? "75%" : "10%",
            marginTop: "1vh",
            transition: "opacity 0.3s ease-in-out",
            display: "flex",
            flexDirection: "row"
        }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: isPortrait ? "column" : "column",
                    height: "100%",
                    width: "50%"
                }}
            >

                <div style={{ height: "100%", width: isPortrait ? "100%" : "100%", borderRadius: "10px" }}>

                    <div style={{ height: "45%", width: "100%", display: "flex", flexDirection: "column" }}>
                        <div style={{ height: "50%", width: "100%", display: "flex", gap: "10px", borderRadius: "10px", justifyContent: "center", alignItems: "center" }}>
                            <button onClick={uploadBackgroundImage} style={{ width: "90%", height: "80%", color: "white", borderRadius: "10px", WebkitTapHighlightColor: "transparent", border: "1px solid white", backgroundColor: "black" }}>{backgroundBitmap ? "Change Background" : "Add Background"}</button>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "50%", width: "100%", gap: "10px", borderRadius: "10px" }}>
                            <div style={{ height: "20px", width: "20px", backgroundColor: backgroundColor, borderRadius: "10px", border: "1px solid white" }}></div>

                            <button onClick={switchBackgroundMode} style={{ height: isPortrait ? "60%" : "20%", width: "20%", color: "black", backgroundColor: "rgba(0, 0, 0, 0.1)", WebkitTapHighlightColor: "transparent", border: "1px solid white", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {!showBackgroundImage ? <FontAwesomeIcon style={{ height: "100%", width: "100%" }} icon={faArrowLeft} color="white" />
                                    : <FontAwesomeIcon style={{ height: "100%", width: "100%" }} icon={faArrowRight} color="white" />}
                            </button>

                            <div style={{ height: "20px", width: "20px", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <FontAwesomeIcon style={{ height: "100%", width: "100%", }} icon={faImage} color="white" />
                            </div>
                        </div>
                    </div>


                    <div style={{ width: "100%", height: "1%", display: "flex", justifyContent: "center", marginTop: "2%", marginBottom: "1%" }}>
                        <div style={{ width: "95%", border: "2px solid white", borderRadius: "10px" }}></div>
                    </div>


                    <div style={{ width: isPortrait ? "100%" : "50%", height: "50%", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "start", color: "#ffffff" }}>

                        <div style={{ display: "flex", alignItems: "start", justifyContent: "center", flexDirection: "column", width: "100%", height: "100%", paddingLeft: "2%" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "start", width: "50%", height: "100%", gap: "2%" }}>
                                <FontAwesomeIcon icon={faGhost} />
                                Opacity
                            </div>
                            <input type="range" min={0} max={100} value={ghostOpacity} onChange={(e) => changeGhostOpacity(e)} />
                            <div style={{ display: "flex", width: '90%', flexDirection: "row", justifyContent: 'center' }}>
                                <div style={{ width: "50%", display: "flex", justifyContent: "start" }}>0</div>
                                <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>{ghostOpacity}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div style={{ height: "100%", width: "50%" }}>
                <HexColorPicker onChange={changeBackgroundColor} style={{ height: "100%", width: isPortrait ? "100%" : "100%" }} color={backgroundColor} />
            </div>



        </div>


    )
}
